import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-brand-dark text-white relative overflow-hidden">
      {/* Decorative shapes â€” keep theme CSS driven */}
      <div className="footer-two__shape-one absolute top-0 left-0 pointer-events-none opacity-20">
        <img src="/assets/images/shapes/footer-v1-shape02.png" alt="" />
      </div>
      <div className="footer-two__shape-two absolute top-0 right-0 pointer-events-none opacity-20">
        <img src="/assets/images/shapes/footer-v1-shape02.png" alt="" />
      </div>
      <div className="footer-two__shape-three float-bob-x absolute bottom-20 left-8 pointer-events-none opacity-10">
        <img src="/assets/images/shapes/footer-v1-shape01.png" alt="" />
      </div>
      <div className="footer-two__shape-four float-bob-x absolute bottom-8 right-8 pointer-events-none opacity-10">
        <img src="/assets/images/shapes/footer-v1-shape04.png" alt="" />
      </div>

      {/* Top section */}
      <div className="relative z-10 pt-16 pb-8">
        <div className="container">
          <div className="row">
            {/* About / logo */}
            <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0ms">
              <div className="mb-8">
                <Link to="/" className="inline-flex items-center rounded-2xl border border-white/15 bg-white px-4 py-3 mb-5">
                  <img
                    src="magizhinilogo.png"
                    width="160"
                    alt="Magizhini"
                    className="max-w-full h-auto"
                  />
                </Link>
                <p className="text-white/60 text-sm leading-relaxed">
                  Over 6 years of experience empowering you with premier software development and training guidance.
                </p>
              </div>
            </div>

            {/* Contact info */}
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="100ms">
              <div className="mb-8">
                <h3 className="text-white font-bold font-heading text-lg mb-6 relative pb-3 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-12 after:h-0.5 after:bg-brand">
                  Find Us
                </h3>
                <ul className="space-y-4 list-none p-0 m-0">
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-brand/20 flex items-center justify-center mt-0.5">
                      <MapPin className="text-brand" size={15} strokeWidth={2} />
                    </span>
                    <div>
                      <span className="block text-xs text-white/50 uppercase tracking-wider mb-1">Address</span>
                      <span className="text-white/80 text-sm leading-relaxed">44 Abelard Ave, Brampton, ON L6Y2K8, Canada.</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-brand/20 flex items-center justify-center mt-0.5">
                      <Phone className="text-brand" size={15} strokeWidth={2} />
                    </span>
                    <div>
                      <span className="block text-xs text-white/50 uppercase tracking-wider mb-1">Get In Touch</span>
                      <a href="tel:+16476874226" className="text-white/80 hover:text-brand text-sm transition-colors">+1(647)-687-4226</a>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-brand/20 flex items-center justify-center mt-0.5">
                      <Mail className="text-brand" size={15} strokeWidth={2} />
                    </span>
                    <div>
                      <span className="block text-xs text-white/50 uppercase tracking-wider mb-1">Quick Email us</span>
                      <a href="mailto:magizhinitech@gmail.com" className="block text-white/80 hover:text-brand text-sm transition-colors">magizhinitech@gmail.com</a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Google Map */}
            <div className="col-lg-5 col-md-6 wow fadeInUp" data-wow-delay="200ms">
              <div className="mb-8">
                <h3 className="text-white font-bold font-heading text-lg mb-6 relative pb-3 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-12 after:h-0.5 after:bg-brand">
                  Our Location
                </h3>
                <div className="rounded-xl overflow-hidden">
                  <iframe
                    src="https://maps.google.com/maps?q=44+Abelard+Ave,+Brampton,+ON+L6Y2K8,+Canada&t=&z=15&ie=UTF8&iwloc=&output=embed"
                    className="w-full h-48 border-0 block"
                    allowFullScreen=""
                    title=" Magizhini technology services office location"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 relative z-10">
        <div className="container">
          <div className="flex flex-col md:flex-row items-center justify-between py-5 gap-4">
            <div className="flex items-center gap-4">
              <span className="text-white/50 text-xs font-medium uppercase tracking-widest">Social</span>
              <div className="flex items-center gap-3">
                <a href="https://facebook.com/magizhinitech" aria-label="Facebook" className="w-8 h-8 rounded-full bg-white/10 hover:bg-brand flex items-center justify-center transition-colors">
                  <i className="fab fa-facebook-f text-white text-xs" aria-hidden="true"></i>
                </a>
                <a href="https://www.instagram.com/magizhinitech" aria-label="Instagram" className="w-8 h-8 rounded-full bg-white/10 hover:bg-brand flex items-center justify-center transition-colors">
                  <i className="fab fa-instagram text-white text-xs" aria-hidden="true"></i>
                </a>
                <a href="https://linkedin.com/company/magizhinitech" aria-label="LinkedIn" className="w-8 h-8 rounded-full bg-white/10 hover:bg-brand flex items-center justify-center transition-colors">
                  <i className="fab fa-linkedin-in text-white text-xs" aria-hidden="true"></i>
                </a>
              </div>
            </div>
            <p className="text-white/50 text-sm">
              &copy;{new Date().getFullYear()}, <Link to="/" className="text-brand hover:text-white transition-colors">Magizhini Technology Services Inc.</Link> All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}